import GenericView from 'js/views/generic.view';
import ImportContactHistoryCollection from 'js/models/import.contact.history.paginated.collection';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/import.contact.history.hbs';
import {el, tagName, template} from "../adapters/backbone-decorators";


require('jqueryUI');

@el("#import-contact-history-container")
@tagName('span')
@template(Template)
class ProfileImportContactHistoryView extends GenericView {
    constructor() {
        super();
        this.collection = new ImportContactHistoryCollection();
        this.collection.on('sync', this.renderCollection, this);
        this.collection.on('change', this.renderCollection, this);
        this.collection.on('all', this.renderCollection, this);
        this.loadCreditsHistory();
    }

    delegateEvents(events) {
        this.cid = 'add-dialog';
        super.delegateEvents(events);
    }

    render() {
        super.render();
    }

    renderCollection() {
        const tempTemplate = this.template({collection: this.collection.data});
        this.$el.html(tempTemplate);
        this.$('[data-i18n]').i18n();
        if (this.pagination) {
            this.pagination.remove();
        }
        // Render collection the 1st time
        this.pagination = new PaginatedView({collection: this.collection});
        this.pagination.render();
        // Replace view's pagination
        this.$('#pagination').html(this.pagination.$el);
    }

    loadCreditsHistory() {
        this.collection.getFirstPage();
        console.info("Fetching import contact history");
    }
}

export default ProfileImportContactHistoryView;
